module.exports = __webpack_public_path__ + "media/images/pc/brands/common/store_comming_soon-a35fbf60dcf674a85fab470c9c320a51.jpg";